var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"peeek-loading"},[_c('ul',{},[_c('div',{staticClass:"loadDescr"},[_vm._v(_vm._s(_vm.loaderDescription[_vm.loaderCount]))]),_c('li'),_c('li'),_c('li'),_c('li'),_c('li'),_c('li'),_c('li'),_c('li'),_c('li'),_c('li')])])
}
var staticRenderFns = []

export { render, staticRenderFns }